module.exports = __webpack_public_path__ + "static/media/IMG-2.254778b2.jpg";